"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var DestinationBridgeContext_1 = require("../../DestinationBridgeContext");
var NetworkManagerContext_1 = require("../../NetworkManagerContext");
var ChainBridgeAPI_1 = require("../SubstrateApis/ChainBridgeAPI");
var _1 = require("./");
var TransitMessageSubstrateReduce_1 = require("../../../reducers/TransitMessageSubstrateReduce");
var SubstrateDestinationAdaptorProvider = function (_a) {
    var children = _a.children;
    var _b = (0, NetworkManagerContext_1.useNetworkManager)(), depositNonce = _b.depositNonce, destinationChainConfig = _b.destinationChainConfig, setTransactionStatus = _b.setTransactionStatus;
    var _c = __read((0, react_1.useState)(0), 2), depositVotes = _c[0], setDepositVotes = _c[1];
    var _d = __read((0, react_1.useReducer)(TransitMessageSubstrateReduce_1.transitMessageReducerSubstrate, {
        txIsDone: false,
        transitMessage: [],
    }), 2), inTransitMessages = _d[0], tokensDispatch = _d[1];
    var _e = __read((0, react_1.useState)(), 2), api = _e[0], setApi = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), initiaising = _f[0], setInitialising = _f[1];
    (0, react_1.useEffect)(function () {
        // Once the chain ID has been set in the network context, the destination configuration will be automatically
        // set thus triggering this
        if (!destinationChainConfig || initiaising || api)
            return;
        setInitialising(true);
        (0, ChainBridgeAPI_1.createApi)(destinationChainConfig.rpcUrl)
            .then(function (api) {
            setApi(api);
            setInitialising(false);
        })
            .catch(console.error);
    }, [destinationChainConfig, api, initiaising]);
    var _g = __read((0, react_1.useState)(undefined), 2), listenerActive = _g[0], setListenerActive = _g[1];
    (0, react_1.useEffect)(function () {
        if (api && !listenerActive && depositNonce) {
            // Wire up event listeners
            // Subscribe to system events via storage
            var unsubscribe = (0, _1.unsubscribeFunc)(api, tokensDispatch, setDepositVotes, setTransactionStatus, destinationChainConfig, depositVotes);
            setListenerActive(unsubscribe);
        }
        else if (listenerActive && !depositNonce) {
            var unsubscribeCall = function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setListenerActive(undefined);
                    return [2 /*return*/];
                });
            }); };
            unsubscribeCall();
        }
    }, [
        api,
        depositNonce,
        depositVotes,
        destinationChainConfig,
        listenerActive,
        setDepositVotes,
        setTransactionStatus,
        tokensDispatch,
    ]);
    return ((0, jsx_runtime_1.jsx)(DestinationBridgeContext_1.DestinationBridgeContext.Provider, __assign({ value: {
            depositVotes: depositVotes,
            setDepositVotes: setDepositVotes,
            tokensDispatch: tokensDispatch,
            disconnect: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (api === null || api === void 0 ? void 0 : api.disconnect())];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
        } }, { children: children }), void 0));
};
exports.default = SubstrateDestinationAdaptorProvider;
//# sourceMappingURL=SubstrateDestinationAdaptorProvider.js.map